
import styled, { css } from 'styled-components';

export const PanelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: #f8f9fa;
  box-sizing: border-box;
`;

export const ContentArea = styled.div`
  flex-grow: 1;
  padding: 20px;
  overflow: auto;
  
  display: flex;
  justify-content: center;
  gap: 15px;
`;

export const ToolbarSlot = styled.div`
  width: 55px; 
  flex-shrink: 0;
  padding-top: 50px;
  
  /* --- Sticky Positioning --- */
  position: sticky;
  top: 20px;
  align-self: flex-start;
`;

export const IconGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const IconButton = styled.button`
  background: ${({ isActive }) => (isActive ? '#e0e0e0' : 'transparent')};
  border: none;
  border-radius: 4px;
  padding: 6px 8px 2px 8px;
  cursor: pointer;
  
  &:hover {
    background: #f1f1f1;
  }
`;

export const DeviceFrameStyled = styled.div`
  background: #111;
  border-radius: 36px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  padding: 12px;
  transition: all 0.3s ease;
  flex-shrink: 0;

  ${({ device, orientation }) => {
    const dimensions = {
      phone: {
        portrait: { width: '375px', height: '667px' },
        landscape: { width: '667px', height: '375px' },
      },
      tablet: {
        portrait: { width: '768px', height: '1024px' },
        landscape: { width: '1024px', height: '768px' },
      },
    };

    const dims = dimensions[device][orientation];

    return css`
      width: ${dims.width};
      height: ${dims.height};
    `;
  }}
`;

export const DeviceScreen = styled.div`
  background: #ffffff;
  height: 100%;
  width: 100%;
  border-radius: 24px;
  overflow-y: auto;
  padding: 20px;
  box-sizing: border-box;
`;